<template>
  <svg
    class="icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <template v-if="name === 'chip'">
      <rect x="7" y="7" width="10" height="10" rx="2" />
      <path d="M9 3v4M12 3v4M15 3v4M9 17v4M12 17v4M15 17v4M3 9h4M3 12h4M3 15h4M17 9h4M17 12h4M17 15h4" />
    </template>
    <template v-else-if="name === 'search'">
      <circle cx="11" cy="11" r="6" />
      <path d="M20 20l-3.5-3.5" />
    </template>
    <template v-else-if="name === 'book'">
      <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v16H6.5A2.5 2.5 0 0 0 4 21.5z" />
      <path d="M4 5.5A2.5 2.5 0 0 1 6.5 8H20" />
    </template>
    <template v-else-if="name === 'route'">
      <circle cx="6" cy="6" r="2" />
      <circle cx="18" cy="18" r="2" />
      <path d="M8 6h6a4 4 0 0 1 4 4v6" />
    </template>
    <template v-else-if="name === 'lock'">
      <rect x="5" y="11" width="14" height="9" rx="2" />
      <path d="M8 11V8a4 4 0 0 1 8 0v3" />
    </template>
    <template v-else-if="name === 'logout'">
      <path d="M9 7V5a2 2 0 0 1 2-2h8v18h-8a2 2 0 0 1-2-2v-2" />
      <path d="M4 12h10M11 9l3 3-3 3" />
    </template>
    <template v-else-if="name === 'chevron'">
      <path d="M9 6l6 6-6 6" />
    </template>
    <template v-else-if="name === 'back'">
      <path d="M15 6l-6 6 6 6" />
    </template>
    <template v-else-if="name === 'server'">
      <rect x="4" y="3" width="16" height="6" rx="1.5" />
      <rect x="4" y="11" width="16" height="6" rx="1.5" />
      <path d="M7 6h.1M7 14h.1" />
    </template>
    <template v-else-if="name === 'file'">
      <path d="M7 3h7l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M14 3v5h5M9 13h6M9 17h4" />
    </template>
    <template v-else-if="name === 'spark'">
      <path d="M12 3l1.4 4.6L18 9l-4.6 1.4L12 15l-1.4-4.6L6 9l4.6-1.4L12 3z" />
      <path d="M18 14l.6 1.8L20.5 16.5 18.6 17.1 18 19l-.6-1.9-1.9-.6 1.9-.7L18 14z" />
    </template>
    <template v-else-if="name === 'price'">
      <path d="M12 3v18" />
      <path d="M16 7.5c0-1.6-1.8-3-4-3s-4 1.2-4 3 1.6 2.8 4 3.2 4 1.4 4 3.3-1.8 3-4 3-4-1.3-4-3" />
    </template>
    <template v-else-if="name === 'edit'">
      <path d="M4 20h4l10-10-4-4L4 16v4z" />
      <path d="M13 7l4 4" />
    </template>
    <template v-else-if="name === 'forum'">
      <path d="M7 16.5 4.5 19V6.5A1.5 1.5 0 0 1 6 5h9a1.5 1.5 0 0 1 1.5 1.5V14H8.2" />
      <path d="M10 10h8.5A1.5 1.5 0 0 1 20 11.5V19l-2.2-2H11.5A1.5 1.5 0 0 1 10 15.5V10z" />
    </template>
    <template v-else-if="name === 'wechat'">
      <path d="M8.5 17.5L5 20.5v-3.2A7 7 0 1 1 9 19" />
      <path d="M9.2 11h.1M13.2 11h.1" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'SiteIcon',
  props: {
    name: { type: String, required: true }
  }
}
</script>

<style scoped>
.icon {
  width: 1.15em;
  height: 1.15em;
  display: inline-block;
  vertical-align: -0.18em;
  flex: none;
}
</style>
